import React from 'react'
import PageTable from "../../components/pageComponents/PageTable";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ActionsIcons from '../../components/atoms/ActionsIcons';
import ReactTooltip from 'react-tooltip';
import EditSolicitudBonoTutoria from './modales/Solicitudes/EditSolicitudBonoTutoria';
import FormSelect from '../../components/atoms/Select';
import { handleFind } from '../../helper/utils';

const TableBonoTutoria = ({ formValues,
    setFormValues,
    setModalEnabled,
    paginator,
    setPaginator,
    keys: KEYS,
    fechasTutoria,
    eliminar,
    keys_filtros }) => {
    const rows = formValues.Items;

    const HEADERS = [
        { col: "col-sm-1", label: "Fecha Ingreso" },
        { col: "col-sm-2", label: "Nombres" },
        //{ col: "col-sm-2", label: "Sede" },
        {
            col: "col-sm-2", label:
                <div className='d-flex justify-content-center'>
                    <FormSelect
                        options={handleFind(formValues.filters, keys_filtros.IdsSedes)}
                        description="Sede"
                        selectedOptions={formValues.selectedFilters?.[keys_filtros.IdsSedes] ?? []}
                        setSelectedOptions={(res) => handleFilterSelected(res, keys_filtros.IdsSedes)}
                    />
                </div>
        },
        { col: "col-sm-2", label: "Region" },
        { col: "col-sm-1", label: "Estado" },
        { col: "col-sm-2", label:
                        <div className='d-flex justify-content-center'>
                            <FormSelect
                                options={handleFind(formValues.filters, keys_filtros.IdsCargos)}
                                description="Cargo"
                                selectedOptions={formValues.selectedFilters?.[keys_filtros.IdsCargos] ?? []}
                                setSelectedOptions={(res) => handleFilterSelected(res, keys_filtros.IdsCargos)}
                            />
                        </div> },
        { col: "col-sm-1", label: "Fecha Inicio Tutoria" },
        { col: "col-sm-2", label: "Fecha Fin Tutoria" },
        { col: "col-sm-1", label:
                <div className='d-flex justify-content-center'>
                    <FormSelect
                        options={handleFind(formValues.filters, keys_filtros.IdsEstadosSolicitud)}
                        description="Est.Solicitud"
                        selectedOptions={formValues.selectedFilters?.[keys_filtros.IdsEstadosSolicitud] ?? []}
                        setSelectedOptions={(res) => handleFilterSelected(res, keys_filtros.IdsEstadosSolicitud)}
                    />
                </div> },
        { col: "col-sm-2", label: "Acciones" }
    ]
    const handleFilterSelected = (res, key) => {
        const updatedSelectedFilters = { ...formValues.selectedFilters, [key]: res };
        setFormValues(lastData => ({ ...lastData, selectedFilters: updatedSelectedFilters }));
    }
    return (
        <PageTable headers={HEADERS} paginator={paginator} setPaginator={setPaginator}>
            <tbody className="listar-tbody">
                {rows.map((row) => (
                    <tr key={row.IdSolicitudBonoTutoria}>
                        <td className="text-center">{row.FechaIngresoTrabajo}</td>
                        <td className="text-center">{row.NombreCompleto}</td>
                        <td className="text-center">{row.NombreSede}</td>
                        <td className="text-center">{row.Region}</td>
                        <td className="text-center">{row.EstadoEmpleado}</td>
                        <td className="text-center">{row.Cargo}</td>
                        <td className="text-center">{row.FechaTutorInicio}</td>
                        <td className="text-center">{row.FechaTutorFin}</td>
                        <td className="text-center">{row.EstadoRegistro}</td>
                        <td className="text-center">
                            <ActionsIcons>
                                {row.MotivoRechazo &&
                                    <ToolTip id={`MotivoRechazo${row.IdSolicitudBonoTutoria}`} text={row.MotivoRechazo} />
                                }
                                {row.PuedeEditar && (row.EstadoRegistro != "Aprobado" && row.EstadoRegistro != "Rechazado") && <FontAwesomeIcon icon='times' size="sm" className="hand-pointer ml-3" title="Eliminar" onClick={() => {
                                    eliminar(row?.IdSolicitudBonoTutoria)
                                }} />}
                                <FontAwesomeIcon
                                    icon="id-card"
                                    title="Ver Detalle Solicitud"
                                    size="lg"
                                    onClick={() =>
                                        setModalEnabled({
                                            isEnable: true,
                                            component: EditSolicitudBonoTutoria,
                                            data: { IdSolicitudBonoTutoria: row.IdSolicitudBonoTutoria, fechasTutoria: fechasTutoria },
                                        })
                                    }
                                />
                            </ActionsIcons>
                        </td>
                    </tr>
                ))}
            </tbody>
        </PageTable>
    );
}

export default TableBonoTutoria;
const ToolTip = ({ id, text }) => (
    <div>
        <FontAwesomeIcon data-tip data-for={id} icon='info-circle' title='Motivo Rechazo' size='lg'
            style={{ color: "#b3a11a" }} />
        <ReactTooltip id={id} place="top" effect="solid" className="tooltip-style">
            Motivo de Rechazo: {text}
        </ReactTooltip>
    </div>
)